import { formatCurrency } from "@helpers/funciones";
import { LoanApplicationOfferResponse } from "@interfaces/MarketPlace";

import { Grid, Box, useTheme, Typography, Button, Divider } from "@mui/material";
import iconDefualt from "@assets/img/defaul_icion_finace.png";
import icon_partner from "@assets/img/market_place/icon_partner.png";

interface CreditOfferCardProps {
  offer: LoanApplicationOfferResponse;
  offers_length: number;
  showButton: boolean;
  onSelectOffer?: () => void;
  index?: number;
}

const fontSize = "14px";

const CreditOfferCard: React.FC<CreditOfferCardProps> = ({ offer, showButton, onSelectOffer }) => {
  const theme = useTheme();

  return (
    <Box sx={{ width: "100%" }}>
      <Box display="flex" justifyContent="center" alignItems="center">
        <div
          style={{
            width: "150px",
            height: "80px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "transparent",
          }}
        >
          <img
            src={
              offer.financial_company?.logo
                ? `${import.meta.env.VITE_URL_STATIC_RESOURCES}/${offer.financial_company.logo}`
                : iconDefualt
            }
            alt={offer.financial_company?.name || "Financiera"}
            style={{
              maxWidth: "100%",
              maxHeight: "100%",
              objectFit: "contain",
            }}
            onError={(e) => {
              (e.currentTarget as HTMLImageElement).src = iconDefualt;
            }}
          />
        </div>
      </Box>

      <Box mt={2} mb={2}>
        <Typography variant={"body1"} fontWeight={500} color={theme?.palette?.primary?.dark} textAlign={"center"}>
          Crédito simple
        </Typography>

        <Box display="flex" justifyContent="center" mt={1}>
          <img
            src={icon_partner}
            alt="Partner"
            style={{
              width: "100%",
              maxWidth: "210px",
            }}
          />
        </Box>
      </Box>

      <Grid container flexDirection={"row"} mt={4}>
        <Grid item xs={6}>
          <Typography sx={{ mb: 1 }} variant={"body1"} fontWeight={500} color={"#6387D4"} textAlign={"center"}>
            Monto Máximo
          </Typography>
          <Typography fontSize={fontSize} fontWeight={400} color={theme?.palette?.primary?.dark} textAlign={"center"}>
            {formatCurrency(offer.loan_amount || 0)} <span style={{ fontSize: 10 }}>MXN</span>
          </Typography>
        </Grid>

        <Divider orientation="vertical" flexItem sx={{ mr: "-2px", border: "1px solid #FF9E1B" }} />

        <Grid item xs={6}>
          <Typography sx={{ mb: 1 }} variant={"body1"} fontWeight={500} color={"#6387D4"} textAlign={"center"}>
            Tasa Anual
          </Typography>
          <Typography fontSize={fontSize} fontWeight={400} color={theme?.palette?.primary?.dark} textAlign={"center"}>
            {offer.interest_rate}% <span style={{ fontSize: 14 }}>anual</span>
          </Typography>
        </Grid>
      </Grid>

      <Grid container flexDirection={"row"} mt={4}>
        <Grid item xs={6}>
          <Typography sx={{ mb: 1 }} variant={"body1"} fontWeight={500} color={"#6387D4"} textAlign={"center"}>
            Tiempo <br /> Formalización
          </Typography>
          <Typography fontSize={fontSize} fontWeight={400} color={theme?.palette?.primary?.dark} textAlign={"center"}>
            2 a 5 días
          </Typography>
        </Grid>

        <Divider orientation="vertical" flexItem sx={{ mr: "-2px", border: "1px solid #FF9E1B" }} />

        <Grid item xs={6}>
          <Typography sx={{ mb: 1 }} variant={"body1"} fontWeight={500} color={"#6387D4"} textAlign={"center"}>
            Garantía
          </Typography>
          <Typography fontSize={fontSize} fontWeight={400} color={theme?.palette?.primary?.dark} textAlign={"center"}>
            N/A
          </Typography>
        </Grid>
      </Grid>

      <Grid container flexDirection={"row"} mt={4}>
        <Grid item xs={6}>
          <Typography sx={{ mb: 1 }} variant={"body1"} fontWeight={500} color={"#6387D4"} textAlign={"center"}>
            Comisiones
          </Typography>
          <Typography fontSize={fontSize} fontWeight={400} color={theme?.palette?.primary?.dark} textAlign={"center"}>
            {offer.opening_fee}%
          </Typography>
        </Grid>
        <Divider orientation="vertical" flexItem sx={{ mr: "-2px", border: "1px solid #FF9E1B" }} />
        <Grid item xs={6}>
          <Typography sx={{ mb: 1 }} variant={"body1"} fontWeight={500} color={"#6387D4"} textAlign={"center"}>
            Plazo
          </Typography>
          <Typography fontSize={fontSize} fontWeight={400} color={theme?.palette?.primary?.dark} textAlign={"center"}>
            12 a {offer.term} meses
          </Typography>
        </Grid>
      </Grid>

      <Box mb={2} mt={2} mx={2}>
        <Typography sx={{ mb: 1 }} variant={"body1"} fontWeight={500} color={"#6387D4"} fontSize={14}>
          Preoferta sujeta a
        </Typography>
        <Box component="ul" sx={{ m: 0, pl: 2, color: theme?.palette?.primary?.dark }}>
          <Box component="li" sx={{ typography: "body2" }}>
            Videollamada con la financiera previa a la formalización.
          </Box>
          <Box component="li" sx={{ typography: "body2" }}>
            Formalización a través de la financiera.
          </Box>
        </Box>
      </Box>
      {showButton && (
        <>
          <Box display="flex" justifyContent="center" mt={4} mb={4}>
            <Button variant="yellow" onClick={onSelectOffer} sx={{ width: "100%", maxWidth: "250px", padding: "5px" }}>
              Elegir preoferta
            </Button>
          </Box>
        </>
      )}
    </Box>
  );
};

export default CreditOfferCard;
